import { ReferralType } from '~/types/referral';
import type { SpecialtyFormConfig } from '~/types/specialty';
import { DentalSpecialty } from '~/types/specialty';

/**
 * Configuration for Orthodontic specialty referral form
 */
export const orthodonticConfig: SpecialtyFormConfig = {
  specialty: DentalSpecialty.ORTHODONTIC,
  displayName: 'Orthodontic',
  requiresToothSelection: true,
  referralTypes: [
    ReferralType.CONSULTATION,
    ReferralType.TREATMENT,
    ReferralType.CONSULTATION_AND_TREATMENT,
  ],
  diagnosisOptions: [],
};
